import { graphql } from 'react-apollo'
import { ADD_REGION_COMMENT } from '../../graphql/mutations'

export default graphql(ADD_REGION_COMMENT, { name: 'addRegionComment' })
